import * as React from "react";
import { PropsWithChildren, useState } from "react";
import { useTranslation } from "react-i18next";

import Submit, { SubmitType } from "../../components/Submit/Submit";
import { StateForm } from "../../useForm";

export type PropsForm = PropsWithChildren<{
  handleSubmit(event: React.FormEvent<HTMLFormElement>): void;
  stateForm: StateForm;
  fromLanding: string;
  infoRequest: string;
}>;

export const Info: React.FC<PropsForm> = (props: PropsForm) => {
  const infoSubmit: SubmitType = {
    textButtonSubmit: "Contactar",
    textButtonSubmitting: "Enviando ...",
    stateForm: props.stateForm,
    textInfo: props.infoRequest,
  };
  const { t } = useTranslation("global");
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);

  return (
    <form
      name="contact"
      method="post"
      onSubmit={(event) => {
        props.handleSubmit(event);
      }}
      className={"form form__contact"}
    >
      <input type="hidden" name="form-name" value="contacto" />
      <div className={"m-info-form__one-line"}>
        <label hidden> {`${t("Nombre")}`} </label>
        <input
          className={"a-input"}
          type="text"
          name="name"
          placeholder="Nombre"
          required
          onBlur={(e) => setIsNameValid(e.target.value.trim() !== "")}
        />
        {!isNameValid && (
          <div className="error-message">{`${t("Ingrese un nombre válido. Este campo no puede quedar vacío")}`}</div>
        )}
      </div>

      <div className={"m-info-form__one-line"}>
        <label hidden>{`${t("Email")}`} </label>
        <input
          className={"a-input"}
          type="email"
          name="email"
          placeholder={`${t("Email")}`}
          required
          onBlur={(e) => setIsEmailValid(e.target.checkValidity())}
        />
        {!isEmailValid && (
          <div className="error-message">{`${t(
            "Ingrese una dirección de correo electrónico válida. Ejemplo: nombre@dominio.com",
          )}`}</div>
        )}
      </div>
      <div className={"m-info-form__one-line"}>
        <label hidden>{`${t("Mensaje")}`} </label>
        <textarea
          className={"a-input"}
          name="message"
          placeholder={`${t("Mensaje")}`}
          required
          onBlur={(e) => setIsMessageValid(e.target.value.trim() !== "")}
        />
        {!isMessageValid && (
          <div className="error-message">{`${t("Ingrese un mensaje válido. Este campo no puede quedar vacío")}`}</div>
        )}
      </div>

      <div className={"m-info-form__check-submit"}>
        <div className={"m-info-form__private"}>
          <label htmlFor={`politica--${props.fromLanding}`} className={"info-form__text-legal"}>
            {`${t(" He leído y acepto la ")}`}{" "}
            <a href="/legal/politica-de-privacidad/" target="_blank" rel="nofollow noopener noreferrer">
              {`${t("política de privacidad")}`}
            </a>{" "}
          </label>
          <input
            type="checkbox"
            name={`politica--${props.fromLanding}`}
            id={`politica--${props.fromLanding}`}
            value="acepta-politica"
            required
            className={"info-form-checkbox"}
          />
          <label htmlFor={`politica--${props.fromLanding}`} className={"m-info-switch"}></label>
        </div>
          <Submit submit={infoSubmit} />
      </div>
    </form>
  );
};
